import { useCallback } from 'react';

import { useMetronomeStore } from './MetronomePlugin';
import { getSetting, settingKeys } from '../../../../../utils/settings';

// Song changes happen from several places that don't go through the metronome plugin:
// the prev/next buttons, the numbered song bar and the continuous-view scroll tracker.
// They all share this so the metronome reacts the same way everywhere — with the
// continuous setting off it stops, with it on it retunes to the new song's BPM.
const useSongChangeMetronome = () => {
  const stopAllMetronomes = useMetronomeStore((state) => state.stopAllMetronomes);
  const activeWorkerRef = useMetronomeStore((state) => state.activeWorkerRef);
  const activeMetronomeId = useMetronomeStore((state) => state.activeMetronomeId);
  const setActiveBpm = useMetronomeStore((state) => state.setActiveBpm);

  return useCallback(
    (newSong) => {
      const continuousMetronome = getSetting(settingKeys.metronomeContinuous);
      const shouldContinue = continuousMetronome !== undefined ? continuousMetronome : false; // Default to false

      if (!shouldContinue) {
        // Setting is OFF - stop the metronome
        stopAllMetronomes();
      } else if (activeWorkerRef && activeMetronomeId && newSong?.bpm) {
        // Setting is ON - update the metronome BPM to match the new song
        activeWorkerRef.postMessage({
          action: 'updateBPM',
          bpm: newSong.bpm,
          timeSignature: newSong.timeSignature || '4/4',
        });
        setActiveBpm(newSong.bpm);
      }
    },
    [stopAllMetronomes, activeWorkerRef, activeMetronomeId, setActiveBpm],
  );
};

export default useSongChangeMetronome;
